// import 'liquid-ajax-cart';
import './liquid-ajax-cart.js';
import { formatMoney, setCookie, getCookie } from './utils.js';

// if (window.liquidAjaxCart) {
//   window.liquidAjaxCart.conf('extraRequestOnError', false);
//   window.liquidAjaxCart.conf('quantityTagDebounce', 0);
//   window.liquidAjaxCart.conf('quantityTagAllowZero', true);
//   window.liquidAjaxCart.conf('updateOnWindowFocus', false);
// }

class CosFreeShipping extends HTMLElement {
  connectedCallback() {
    if (!window.Shopify) return;
    
    const settings = this.dataset.settings ? JSON.parse(this.dataset.settings) : {};
    if (!settings.market || !settings.translations) return;
    
    const isEU = settings.market.country_code === 'EU';

    const freeShippingLimit = ((settings.free_shipping) ? 10 : (isEU) ? settings.market.free_shipping * window.Shopify.currency.rate : settings.market.free_shipping) * 100;
    if (!freeShippingLimit) return;

    isEU && settings.continent !== 'Europe' && this.remove();
    this.innerHTML = settings.total_price < freeShippingLimit
      ? `<div>${settings.translations.spend_more.replace('spend_amount', formatMoney(freeShippingLimit - settings.total_price, 'amount_no_decimals'))}</div>`
      : `<div>${settings.translations.shipping}</div><div>${settings.translations.free}</div>`;
  }
}
// check if el is not initialized
if (!customElements.get('cos-free-shipping')) customElements.define('cos-free-shipping', CosFreeShipping);

class CosPromo extends HTMLElement {
  connectedCallback() {
    if (!window.custom) return;
    if (!window.custom.currency) return;
    if (!window.custom.currency.rate) return;

    if (getCookie('utm_active')) return this.cancelPromo();

    this.settings = this.dataset.settings ? JSON.parse(this.dataset.settings) : {};
    // const params = new URLSearchParams(document.location.search);
    
    this.settings.url_params && this.settings.url_params.forEach((param) => {
      if (document.location.search.includes(param)) {
        setCookie('utm_active', true, this.settings.cookie_duration_days || 14);
        return this.cancelPromo();
      }
    });

    // this.wrapper = this.closest('cos-promo-wrapper');
    // this.run();

    if (window.liquidAjaxCart && window.liquidAjaxCart.init) {
      // if Liquid Ajax Cart is already initialized
      this.run();
    } else {
      // wait for Liquid Ajax Cart to be initialized
      document.addEventListener('liquid-ajax-cart:init', this.run());
    }

    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
      const {cart} = event.detail;
      if (!cart) return;

      this.run(cart.original_total_price);
    });
  }

  run(totalPrice) {
    const converted = this.settings.promo_limit * window.custom.currency.rate;
    const total = totalPrice || this.settings.total_price;

    if (total < converted) {
      this.classList.remove('is-valid');
    } else {
      this.classList.add('is-valid');
    }

    this.style.setProperty('--progress', `${total / converted}`);
  }

  cancelPromo() {
    this.inert = true;
  }
}
// check if el is not initialized
if (!customElements.get('cos-promo')) customElements.define('cos-promo', CosPromo);

class CosPromoWrapper extends HTMLElement {
  connectedCallback() {
    const cosPromo = document.querySelector('cos-promo');
    if (!cosPromo) return;

    const alreadyCosPromo = this.querySelector('cos-promo');
    if (alreadyCosPromo) return;

    // if (this.dataset.settings) {
    //   const settings = JSON.parse(this.dataset.settings);

    //   cosPromo.setAttribute('settings', settings);
    // }

    this.appendChild(cosPromo.cloneNode(true));
  }
}
// check if el is not initialized
if (!customElements.get('cos-promo-wrapper')) customElements.define('cos-promo-wrapper', CosPromoWrapper);

class CosCartDonationWrapper extends HTMLElement {
  connectedCallback() {
    const cosDonation = document.querySelector('cos-cart-donation');
    if (!cosDonation) return;

    const alreadyCosDonation = this.querySelector('cos-cart-donation');
    if (alreadyCosDonation) return;

    // if (this.dataset.settings) {
    //   const settings = JSON.parse(this.dataset.settings);

    //   cosDonation.setAttribute('settings', settings);
    // }

    this.replaceRegex = /lazy-loaded|lazy-waiting/g;
    const cosDonationClone = cosDonation.cloneNode(true);
    cosDonationClone.innerHTML = cosDonationClone.innerHTML.replace(this.replaceRegex, '');

    this.appendChild(cosDonation.cloneNode(true));
    window.handleImages(this);
  }
}
// check if el is not initialized
if (!customElements.get('cos-cart-donation-wrapper')) customElements.define('cos-cart-donation-wrapper', CosCartDonationWrapper);

// var _learnq = _learnq || [];
// Quick Add Functionality
function QuickAdd(id, status, dispatch) {
  if (!window.liquidAjaxCart) throw new Error('liquidAjaxCart not defined'); 
  if (!id) throw new Error('id not defined');

  document.dispatchEvent(new CustomEvent('cos.cart.adding'));  

  const properties = {
    'Status': status || "In stock"
  };

  if ((status === 'Pre-order' || status === 'PRE-ORDER') && dispatch) {  
    properties['_Dispatch date'] = getDispatchDate(dispatch);
  }

  // Request body data you want to send to Shopify
  const body = {
    items: [
      {
        id,
        quantity: 1,
        properties
      }
    ]  
  };

  window.liquidAjaxCart.add(body, {
    // firstCallback: function(requestState) {   
    //   /**
    //    * This callback function will be called first after the request is performed,
    //    * thus none of request subscribers knows the result of the request,
    //    * thus Cart state is not updated yet, sections are not updated yet,
    //    * everything is not updated yet.
    //    */
    // },
    lastCallback: function(requestState) {        
      if (!requestState?.responseData?.ok) return;

      requestState?.responseData?.body?.items.forEach(item => {
        document.querySelectorAll(`[data-lineitem-key="${item.key}"]`).forEach(element => {
          element.classList.add('last-added');
        });
        
        // const { product_title, product_id, product_type, image, url, vendor, price, original_price, properties, quantity } = item;
        
        // console.log('Last added item ' , lastAddedItem);
        (window._learnq || []).push(['track', 'Added to Cart', {
          Name: item.product_title,
          ProductID: item.product_id,
          Categories: item.product_type,
          ImageURL: item.image,
          URL: window.theme.routes.secure_url + item.url,
          Brand: item.vendor,
          Price: item.price/100,
          CompareAtPrice: item.original_price/100,
          Status: item.properties.Status,
          DispatchDate: item.properties['_Dispatch date'],
          Quantity: item.quantity
        }]);
        // console.log('_learnq ' , _learnq)

        // RTB Shopping cart - add-to-cart code
        (window.rtbhEvents || []).push({
          eventType: 'basketadd', offerId: item.product_id.toString()
        }, {
          eventType: 'uid',
          id: window.custom.uid
        });
      });
      /**
       * This callback-function will be called the latest
       * among request subscribers,
       * thus all the request subscribers are executed,
       * thus Cart state is updated, sections are updated,
       * everything is updated.
       */
       document.dispatchEvent(new CustomEvent('cos.cart.added'));                  
    },
    info: {
      /**
       * Any additional data you want to attach to the Request state object.
       * Don't use the "initiator" and the "cancel" keys.
       */
      // myParameter: 'value'
    },
  
    // whether the request should go to the beginning of the queue rather than to the end
    important: false
  });
}

function getDispatchDate(dispatch) {
  if (dispatch.includes('/')) {
    // converting from DD/MM/YYYY to YYYY-MM-DD
    const converted = dispatch.split('/').reverse().join('-');
    const date = new Date(`${converted}T00:00:00`);
    const result = date.toLocaleDateString('en-us', {year: 'numeric', month: 'short', day: 'numeric'});
    
    return result;
  }

  return dispatch;
}

function runWhenInit() {
  window.QuickAdd = QuickAdd;
}

if (window.liquidAjaxCart?.init) {
  // if Liquid Ajax Cart is already initialized
  runWhenInit();
} else {
  // wait for Liquid Ajax Cart to be initialized
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}

(() => {
  // --- 1) What CSS do you want? Edit here.
  const CSS = `
    .wallet-cart-grid {
      gap: 4px !important;
      flex-direction: row !important;
      margin: 0 !important;
    }
    .wallet-cart-button-container {
      margin: 0 !important;
    }
  `;

  // --- helper: inject <style> once per shadow root
  function injectStyle(shadowRoot) {
    if (!shadowRoot || shadowRoot.__walletGridStyled) return;
    const style = document.createElement('style');
    style.textContent = CSS;
    shadowRoot.appendChild(style);
    shadowRoot.__walletGridStyled = true;
  }

  // --- helper: wait for .wallet-cart-grid then inject
  function whenWalletGridReady(root) {
    if (!root) return;
    if (root.querySelector?.('.wallet-cart-grid')) {
      injectStyle(root);
      return;
    }
    const mo = new MutationObserver(() => {
      if (root.querySelector?.('.wallet-cart-grid')) {
        injectStyle(root);
        mo.disconnect();
      }
    });
    mo.observe(root, { subtree: true, childList: true });
  }

  // --- 2) Handle the case where the shadow root is OPEN and already on the page
  function tryOpenShadowNow() {
    const host = document.querySelector('shopify-accelerated-checkout-cart');
    if (host?.shadowRoot) whenWalletGridReady(host.shadowRoot);
  }

  // --- 3) Observe future hosts added with an OPEN shadow
  const docObserver = new MutationObserver(() => {
    document.querySelectorAll('shopify-accelerated-checkout-cart').forEach(host => {
      if (host.shadowRoot) whenWalletGridReady(host.shadowRoot);
    });
  });
  docObserver.observe(document.documentElement, { childList: true, subtree: true });

  // --- 4) EARLY hook: catch even CLOSED shadows as they are created
  // Run this before components attach their shadow to affect closed roots too.
  const origAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function(init) {
    const shadow = origAttachShadow.call(this, init);
    if (this.matches?.('shopify-accelerated-checkout-cart')) {
      // shadow may be open or closed; we still hold the reference here
      whenWalletGridReady(shadow);
    }
    return shadow;
  };

  // kick it off for already-present elements
  tryOpenShadowNow();
})();

// (() => {
//   // ========== 1) Define your CSS per host ==========
//   // Edit these blocks to what you actually need.
//   // They are injected INSIDE each host's shadow root.
//   const STYLES = {
//     'shopify-accelerated-checkout-cart': `
//       .wallet-cart-grid {
//         gap: 4px !important;
//         flex-direction: row !important;
//         margin: 0 !important;
//       }
//       .wallet-cart-button-container {
//         margin: 0 !important;
//       }
//     `,
//     'shop-pay-wallet-button': `
//       .logo-only>svg, 
//       .button-content>svg {
//         height: 1.1em;
//         width: auto;
//       }
//     `,
//     'shopify-amazon-pay-button': `
//       .logo-only>svg, 
//       .button-content>svg {
//         height: 1.1em;
//         width: auto;
//       }
//     `,
//     'shopify-apple-pay-button': `
//       .logo-only>svg, 
//       .button-content>svg {
//         height: 1.1em;
//         width: auto;
//       }
//     `,
//     'shopify-google-pay-button': `
//       .logo-only>svg, 
//       .button-content>svg {
//         height: 1.1em;
//         width: auto;
//       }
//     `,
//     'shopify-paypal-button': `
//       .logo-only>svg, 
//       .button-content>svg,
//       .paypal-button-label-container img {
//         height: 20px;
//         width: auto;
//       }
//     `,
//   };

//   // ========== 2) Utilities ==========
//   const processed = new WeakSet();              // ShadowRoot -> processed?
//   const styleSheets = new Map();                // host tagName -> ConstructedStyleSheet (optional)

//   function ensureSheetFor(tag) {
//     // Use Constructed Stylesheets when supported (cleaner re-renders).
//     if (!('adoptedStyleSheets' in Document.prototype)) return null;
//     if (styleSheets.has(tag)) return styleSheets.get(tag);
//     const css = STYLES[tag];
//     if (!css) return null;
//     const sheet = new CSSStyleSheet();
//     sheet.replaceSync(css);
//     styleSheets.set(tag, sheet);
//     return sheet;
//   }

//   function injectCSS(shadow, hostTag) {
//     if (!shadow || processed.has(shadow)) return;
//     const css = STYLES[hostTag];
//     if (!css) return;

//     // Prefer Constructed Stylesheets if available
//     const sheet = ensureSheetFor(hostTag);
//     if (sheet && Array.isArray(shadow.adoptedStyleSheets)) {
//       // Avoid duplicates
//       if (!shadow.adoptedStyleSheets.includes(sheet)) {
//         shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
//       }
//     } else {
//       // Fallback: <style> tag
//       const style = document.createElement('style');
//       style.textContent = css;
//       shadow.appendChild(style);
//     }

//     processed.add(shadow);
//   }

//   // Handle a host with (open or closed) shadow root we just observed
//   function onShadowCreated(hostEl, shadow) {
//     const tag = hostEl.tagName.toLowerCase();
//     injectCSS(shadow, tag);

//     // If this shadow contains nested hosts, we still need to catch them.
//     // For open shadow: observe DOM changes to find nested hosts as they appear.
//     if (shadow && 'querySelectorAll' in shadow) {
//       // Initial sweep for any nested hosts already present
//       discoverNestedHosts(shadow);
//       // Observe future additions
//       const mo = new MutationObserver(() => discoverNestedHosts(shadow));
//       mo.observe(shadow, { childList: true, subtree: true });
//     }
//   }

//   function discoverNestedHosts(rootLike) {
//     // Look for any known hosts inside this root (open ShadowRoot or Document)
//     const selectors = Object.keys(STYLES).join(',');
//     const hosts = rootLike.querySelectorAll?.(selectors) || [];
//     hosts.forEach(h => {
//       // If it has an open shadow, inject now
//       if (h.shadowRoot) onShadowCreated(h, h.shadowRoot);
//       // If closed, we rely on the attachShadow hook below (must run early)
//     });
//   }

//   // ========== 3) Hook attachShadow to catch OPEN & CLOSED shadows ==========
//   const origAttachShadow = Element.prototype.attachShadow;
//   Element.prototype.attachShadow = function(init) {
//     const shadow = origAttachShadow.call(this, init);
//     const tag = this.tagName?.toLowerCase?.();
//     if (tag && STYLES[tag]) {
//       // Known host: inject immediately
//       onShadowCreated(this, shadow);
//     }
//     return shadow;
//   };

//   // ========== 4) Handle already-present elements (open shadows) ==========
//   function primeExisting() {
//     // Start from the document (light DOM)
//     discoverNestedHosts(document);

//     // For the top-level cart host (if already in DOM and open)
//     document.querySelectorAll('shopify-accelerated-checkout-cart').forEach(host => {
//       if (host.shadowRoot) onShadowCreated(host, host.shadowRoot);
//     });

//     // Also watch the light DOM for late-mounted hosts
//     const mo = new MutationObserver(() => {
//       discoverNestedHosts(document);
//       document.querySelectorAll('shopify-accelerated-checkout-cart').forEach(host => {
//         if (host.shadowRoot) onShadowCreated(host, host.shadowRoot);
//       });
//     });
//     mo.observe(document.documentElement, { childList: true, subtree: true });
//   }

//   primeExisting();
// })();